import React from "react";
import { TabbedShowLayout, Tab, ShowProps } from "react-admin";
import SanitizedGrid from "components/SanitizedGrid";
import { Grid } from "@material-ui/core";
import { GetParam } from "utils/tools";
import Summary from "./Summary";
import AcademicTerm from "./CcaAcademicTerm";
import Holiday from "./CcaHoliday";
import ShowWrapper from "../../components/ShowWrapper";

const AcademicYearShow = (props: ShowProps) => {
  const param = GetParam();
  const { id } = props;

  const breadcrumb = [
    { title: "Schools", link: `/schools` },
    {
      link: `/schools/${param.get("schoolId")}/show/4`,
      title: "Academic Years",
    },
    {
      link: ``,
      title: id,
    },
  ];

  return (
    <>
      <ShowWrapper
        breadcrumb={breadcrumb}
        customName={{ resourceName: "CCA Academic Year", propertyName: "name" }}
        actions={false}
        {...props}
      >
        <SanitizedGrid container spacing={2}>
          <Grid item xs={12}>
            <TabbedShowLayout>
              <Tab label="Summary">
                <Summary {...props} />
              </Tab>
              <Tab label="Academic Term">
                <AcademicTerm {...props} />
              </Tab>
              <Tab label="Holiday">
                <Holiday {...props} />
              </Tab>
            </TabbedShowLayout>
          </Grid>
        </SanitizedGrid>
      </ShowWrapper>
    </>
  );
};

export default AcademicYearShow;
